import React, { useContext, useEffect, useState } from "react";
import { CloseOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { Modal, Row, Col, Radio } from "antd";
import { Button } from "antd/es/radio";
import { DashboardContext } from "../../../store/context/DashboardContext";
import { formatCurrencyWithCode } from "../../../utils/helper/format";
import { useTenant } from "../../../store/context/tenant-context";

const SelectAccoutModal = ({ isModalVisible, handleOk, handleCancel }) => {
  const [selectedAccount, setSelectedAccount] = useState(null);
  const tenant = useTenant();
  const { depositPolicies } = useContext(DashboardContext);

  useEffect(() => {
    // If there's only one account, select it automatically
    if (depositPolicies.length === 1) {
      setSelectedAccount(depositPolicies[0].accountNumber);
    }
  }, [depositPolicies]);

  // useEffect(() => {
  //   if (!isModalVisible) {
  //     // If there's only one account, keep it selected
  //     if (depositPolicies.length === 1) {
  //       setSelectedAccount(depositPolicies[0].accountNumber);
  //     } else {
  //       setSelectedAccount(null);
  //     }
  //   }
  // }, [isModalVisible, depositPolicies]);

  useEffect(() => {
    if (!selectedAccount && depositPolicies.length) {
      setSelectedAccount(depositPolicies[0].accountNumber);
    }
  }, [selectedAccount, depositPolicies]);

  return (
    <Modal
      open={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={
        <Button
          type="primary"
          onClick={() => handleOk(selectedAccount)}
          style={{ backgroundColor: tenant.theme.colorPrimary, color: "#fff" }}
          className="h-full px-5 py-1 text-center shadow-none"
        >
          Apply
        </Button>
      }
      width={700}
      centered
      title={<h3 className="text-center">Select Account</h3>}
    >
      <h3 className="mb-4">Please select an account</h3>

      <Row gutter={[16, 16]} justify="space-between">
        {depositPolicies.map((account) => (
          <Col xs={24} md={12} key={account.accountNumber}>
            <div
              onClick={() => setSelectedAccount(account.accountNumber)}
              style={{
                border: selectedAccount === account.accountNumber
                  ? `2px solid ${tenant.theme.colorPrimary}`
                  : "1px solid #e8e8e8",
                borderRadius: 16,
                padding: "16px 18px",
                backgroundColor: selectedAccount === account.accountNumber ? "#f0faf5" : "#fff",
                cursor: "pointer",
                height: "100%",
                transition: "all 0.2s",
                boxShadow: selectedAccount === account.accountNumber
                  ? `0 0 0 3px ${tenant.theme.colorPrimary}20`
                  : "0 1px 6px rgba(0,0,0,0.06)",
              }}
            >
              {/* Header row */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
                <div>
                  <p style={{ fontWeight: 700, fontSize: 15, color: "#111", margin: 0 }}>
                    {account.accountType}
                  </p>
                  <p style={{ fontSize: 12, color: "#888", margin: "4px 0 0", fontFamily: "monospace", letterSpacing: 1 }}>
                    {account.accountNumber}
                  </p>
                </div>
                {selectedAccount === account.accountNumber ? (
                  <CheckCircleOutlined style={{ fontSize: 22, color: tenant.theme.colorPrimary }} />
                ) : (
                  <span style={{ width: 22, height: 22, borderRadius: "50%", border: "2px solid #ccc", display: "inline-block", flexShrink: 0 }} />
                )}
              </div>

              {/* Balance row */}
              <div style={{ borderTop: "1px solid #f0f0f0", paddingTop: 12 }}>
                <p style={{ fontSize: 11, color: "#aaa", textTransform: "uppercase", letterSpacing: "0.8px", margin: "0 0 4px" }}>
                  Available Balance
                </p>
                <p style={{ fontSize: 20, fontWeight: 800, color: tenant.theme.colorPrimary || "#0b3d2e", margin: 0 }}>
                  ₦{new Intl.NumberFormat("en-NG", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(account.availableBalance ?? account.accountBalance ?? 0)}
                </p>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Modal>
  );
};

export default SelectAccoutModal;
